<template>
	<div class="form">
		<h4 class="step-title">What is your name?</h4>
		<ValidationObserver v-slot="{ errors, handleSubmit }" @submit.prevent>
			<div class="step-content d-flex flex-column align-items-center">
				<div class="step-item">
					<div class="form-group mb-0 row">
						<div class="col-12 col-md-6 mt-4">
							<ValidationProvider
								mode="eager"
								vid="firstName"
								name="First name"
								rules="required"
							>
								<input
									id="firstName"
									class="form-control"
									placeholder="First"
									type="text"
									v-model="lead.firstName"
								/>
							</ValidationProvider>
							<div
								v-if="
									errors['firstName'] &&
									errors['firstName'].length > 0
								"
							>
								<div class="alert alert-danger mt-2">
									{{ errors["firstName"][0] }}
								</div>
							</div>
						</div>

						<div class="col-12 col-md-6 mt-4">
							<ValidationProvider
								mode="eager"
								vid="lastName"
								name="Last name"
								rules="required"
							>
								<input
									id="lastName"
									class="form-control"
									placeholder="Last"
									type="text"
									v-on:keyup.enter="enterKeyup"
									v-model="lead.lastName"
								/>
							</ValidationProvider>
							<div
								v-if="
									errors['lastName'] &&
									errors['lastName'].length > 0
								"
							>
								<div class="alert alert-danger mt-2">
									{{ errors["lastName"][0] }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="step-item">
					<button
						class="btn btn-step btn-lg form-control"
						ref="complete"
						v-on:click="handleSubmit(complete)"
					>
						Continue
					</button>
				</div>
			</div>
		</ValidationObserver>
	</div>
</template>

<script>
import { extend } from "vee-validate";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
	...required,
	message: "{_field_} is required.",
});

export default {
	name: "Name",
	components: {
		ValidationProvider,
		ValidationObserver,
	},
	props: {
		lead: Object,
	},
	methods: {
		enterKeyup: function () {
			this.$refs.complete.click();
		},
		complete: function () {
			this.$emit(
				"complete",
				this.$options.name,
				this.lead.firstName + ", " + this.lead.lastName
			);
		},
	},
};
</script>
